import {Pipe, PipeTransform} from '@angular/core';
import {PropertyType} from '@aztrix/models';
import {
  ProposalLanguageRepresentation,
  RequestedPropertyTypeDescriptionRepresentation,
} from '@aztrix/sdk';

import {getPropertyTypeDescription} from '../../helpers/proposal-functions';

@Pipe({name: 'proposalPropertyDescription'})
export class ProposalPropertyDescriptionPipe implements PipeTransform {
  transform(
    language: ProposalLanguageRepresentation | undefined,
    requestedId: string | undefined,
    type: PropertyType | undefined
  ): RequestedPropertyTypeDescriptionRepresentation | undefined {
    return getPropertyTypeDescription(language, requestedId, type);
  }
}
